import React, { useCallback, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import SortableTable from "../../Components/Table/SortableTable";
import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import { Button, Dialog, Grid } from "@material-ui/core";
import HereDotComModal from "../../Components/Modal/HereDotComModal";
import { getHereAccounts } from "../../Services/API/HereDotCom";
import Signifier from "../../Components/Signifier";
import HereDotComTableCell from "../../Components/Table/HereDotComTableCell";
import axios from "axios";

function HereDotComPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "90%",
      marginBottom: "50px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    addButton: {
      marginTop: "25px",
      [theme.breakpoints.down("sm")]: {
        marginTop: "0px",
      },
    },
  }));

  const classes = useStyles();

  const [showSignifier, setShowSignifier] = useState(false);
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [data, setData] = useState([]);
  axios.defaults.headers.common["client"] = "";

  const columns = [
    { label: "Name", propName: "name" },
    { label: "Beta Clients", propName: "betaSize" },
    { label: "Production Clients", propName: "prodSize" },
    { label: "Is Production", propName: "isProductionString" },
  ];

  const compare = (a, b) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  };

  const loadAccounts = useCallback(() => {
    setLoading(true);
    setError(false);
    return getHereAccounts()
      .then((response) => {
        response.sort((a, b) => {
          const order = compare(a.name, b.name);
          if (order !== 0) return order;
          return a[1] - b[1];
        });
        for (var i in response) {
          response[i].betaSize = response[i].clientHereDotComBetaAccounts.length;
          response[i].prodSize =
            response[i].clientHereDotComProductionAccounts.length;
          response[i].isProductionString = response[i].isProduction
            ? "Yes"
            : "No";
        }
        setData(response);
      })
      .catch((err) => {
        console.error("Failed to load Here.com accounts:", err);
        setError(true);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadAccounts();
  }, [loadAccounts]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message="Account Added"
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">Here.com</h1>
        <div className={classes.root}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <Button
                color="primary"
                className={classes.addButton}
                style={{ color: "white", marginBottom: "10px" }}
                type="submit"
                variant="contained"
                onClick={() => setOpenModal(true)}
              >
                Add Account
              </Button>
            </Grid>
          </Grid>
          <SortableTable
            columns={columns}
            tableData={data}
            loading={loading}
            error={error}
            onRetry={loadAccounts}
            rowComponent={HereDotComTableCell}
          />
        </div>
      </div>
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <HereDotComModal
          openModal={setOpenModal}
          setData={setData}
          setShowSignifier={setShowSignifier}
          setShowError={setShowError}
        />
      </Dialog>
    </>
  );
}

export default HereDotComPage;
